module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }